import { createUseStyles } from "react-jss";

export const BatchItemStyle = createUseStyles((theme: any) => ({
    container: {
        height: 30,
        display: "flex",
    },
    content: {
        backgroundColor: theme.colors.palette.greyBlue,
        display: "flex",
        justifyContent: "center",
        gap: 30,
        borderRadius: 20,
        paddingLeft: 5,
        paddingRight: 5,
        height: 30,
    },
    text: {
        display: "flex",
        alignContent: "center",
        padding: 5,
        width: "100%",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        fontWeight: "600",
        color: theme.colors.palette.shadowBlack,
        opacity: 1,
    },
    button: {
        fontWeight: 600,
        color: theme.colors.palette.red,
    },
}));
